var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.401,
    height: 14.837,
    viewBox: "0 0 23.401 14.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Player_pool",
    "data-name": "Player pool",
    transform: "translate(-110.075 -3.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "players_icon",
    "data-name": "players icon",
    d: "M2.163-15.266a12.954,12.954,0,0,1,3.037.4,9.878,9.878,0,0,1,3.037,1.294,2.5,2.5,0,0,1,1.394,2.041v2.639H3.258v-2.639a4.41,4.41,0,0,0-2.091-3.684A7.528,7.528,0,0,1,2.163-15.266Zm-11.5.4a12.954,12.954,0,0,1,3.037-.4,12.954,12.954,0,0,1,3.037.4A9.573,9.573,0,0,1-.252-13.574a2.5,2.5,0,0,1,1.369,2.041v2.639H-13.77v-2.639a2.5,2.5,0,0,1,1.394-2.041A9.878,9.878,0,0,1-9.338-14.868ZM-4.086-18.3a2.981,2.981,0,0,1-2.216.946,3.062,3.062,0,0,1-2.24-.946,3.062,3.062,0,0,1-.946-2.24,3.062,3.062,0,0,1,.946-2.24A3.062,3.062,0,0,1-6.3-23.73a2.981,2.981,0,0,1,2.216.946,3.1,3.1,0,0,1,.921,2.24A3.1,3.1,0,0,1-4.086-18.3Zm8.489,0a3.062,3.062,0,0,1-2.24.946A3.062,3.062,0,0,1-.078-18.3a3.062,3.062,0,0,1-.946-2.24,3.062,3.062,0,0,1,.946-2.24,3.062,3.062,0,0,1,2.24-.946,3.062,3.062,0,0,1,2.24.946,3.062,3.062,0,0,1,.946,2.24A3.062,3.062,0,0,1,4.4-18.3Z",
    transform: "translate(123.845 27.065)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayers);
export default __webpack_public_path__ + "static/media/players.c668cd82672b461f990f7e8986148b66.svg";
export { ForwardRef as ReactComponent };